
import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VAutocomplete,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VTooltip,
  VMenu,
  VTextField,
  VSnackbar,
  VForm,
  VDataTable,
  VProgressLinear,
  VAlert,
  VDialog,
  VCard,
  VCheckbox,
  VSwitch,
  VDatePicker,
  VTimePicker,
  VSelect,
  VTextarea,
  transitions,
  VImg,
  VBadge,
  VExpansionPanel,
  VDivider,
  VProgressCircular,
  VSpeedDial,
  VTabs,
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import { i18n } from '../../../supplier/src/utils/locales/default';

Vue.use(Vuetify, {
  components: {
    VApp,
    VAutocomplete,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VTooltip,
    VMenu,
    VTextField,
    VSnackbar,
    VForm,
    VDataTable,
    VProgressLinear,
    VAlert,
    VDialog,
    VCard,
    VCheckbox,
    VSwitch,
    VDatePicker,
    VTimePicker,
    VSelect,
    VTextarea,
    transitions,
    VImg,
    VBadge,
    VExpansionPanel,
    VDivider,
    VProgressCircular,
    VSpeedDial,
    VTabs,
  },
  theme: {
    primary: '#1D7EC3',
    secondary: '#666666',
    accent: '#d9d9d9',
    error: '#F21C2A',
    info: '#b45f06',
    success: '#38761d',
    warning: '#bf9000',
    submitBtn: "#37ee4a",
    textColor: "#707070",
    menuBackground: '#21658c',
    menuText: '#ffffff',
    menuSelectedText: '#21658c',
    menuSelectedItem: '#ffffff',
    appBackground: "#F6F6F6",
  },
  options: {
    customProperties: true,
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})
